// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__3o7AY","modalLeftRight":"style_modalLeftRight__7TggG","modalFade":"style_modalFade__1u35f","cross":"style_cross__uSDE6","easyZoom":"style_easyZoom__3tO1E"};